import JSEncrypt from 'jsencrypt'

const publicKey = 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAtAlik9vldY6zgjj9zpZ2w0H/eKdw60cUF0SFE86pnGb+fPnk6CN8rxaUjZmKOBpIkr6u07RHVAlDhln5PYflGMFZ88232jsfPKh5OFXB1B7Nstvj8R4OlH1+33XCnd1u+dv2E3Xu8IHv899/rjUJbc1RYpHoBN/q4dZMGadF7Yq5zDVruNBr+he3RKle1UtcWDDUJqYMBVPgvRP00SxJiTTvrJsAzhSRhoEXEK/R4d5F9ZnUpKcHR4u4Zb6IP/ijSCnTqoqbwJqiwNhKxIMgCUzgX/nhNy6Moj7WmS071Lb4wE+WKqMDozRlG5vsSf7pTiLIpoh5eBvdaKHSOaDBUwIDAQAB'

/**
 * 使用 RSA 公钥加密数据
 * @param {string} data 待加密的字符串
 * @returns {string} 加密后的 Base64 字符串
 */
export function encryptData(data) {
    const encryptor = new JSEncrypt()
    encryptor.setPublicKey(publicKey)
    const encrypted = encryptor.encrypt(data)

    if (encrypted === false) {
        throw new Error('RSA加密失败')
    }

    return encrypted
}

export default {
    encryptData,
    publicKey
}



// WEBPACK FOOTER //
// ./src/utils/cryptoService.js